<template>
  <div>
    <b-card
      no-body
      class="mb-0"
    >
      <div class="m-2">
        <b-form
          class="p-2"
          @reset.prevent="resetForm"
        >
          <h6
            class="text-primary"
          >
            <feather-icon icon="AlertCircleIcon" />
            <span class="align-middle ml-25">Info Institucional</span>
          </h6>
          <hr style="border-top: 2px solid #7367f0;margin-bottom: 1rem !important;margin-top: 0 !important;">

          <b-row>
            <b-col
              md="6"
            >
              <b-form-group
                label="Misión"
                label-for="mision"
              >
                <b-form-textarea
                  id="mision"
                  v-model="dataRegister.mision"
                  rows="3"
                />
              </b-form-group>
            </b-col>
            <b-col
              md="6"
            >
              <b-form-group
                label="Visión"
                label-for="vision"
              >
                <b-form-textarea
                  id="vision"
                  v-model="dataRegister.vision"
                  rows="3"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              md="6"
            >
              <b-form-group
                label="Quienes somos"
                label-for="quienesSomos"
              >
                <b-form-textarea
                  id="quienesSomos"
                  v-model="dataRegister.quienesSomos"
                  rows="3"
                />
              </b-form-group>
            </b-col>
            <b-col
              md="6"
            >
              <b-form-group
                label="Historia"
                label-for="historia"
              >
                <b-form-textarea
                  id="historia"
                  v-model="dataRegister.historia"
                  rows="3"
                />
              </b-form-group>
            </b-col>
          </b-row>

          <h6
            class="text-primary"
          >
            <feather-icon icon="MapIcon" />
            <span class="align-middle ml-25">Ubicación</span>
          </h6>
          <hr style="border-top: 2px solid #7367f0;margin-bottom: 1rem !important;margin-top: 0 !important;">

          <b-row>
            <b-col
              md="4"
            >
              <b-form-group
                label="Dirección Principal"
                label-for="direccionPrincipal"
              >
                <b-form-input
                  id="direccionPrincipal"
                  v-model="dataRegister.direccionPrincipal"
                  autofocus
                  trim
                  placeholder=""
                />
              </b-form-group>
            </b-col>
            <b-col
              md="4"
            >
              <b-form-group
                label="Latitud"
                label-for="latitudPrincipal"
              >
                <b-form-input
                  id="latitudPrincipal"
                  v-model="dataRegister.latitudPrincipal"
                  autofocus
                  trim
                  placeholder=""
                />
              </b-form-group>
            </b-col>
            <b-col
              md="4"
            >
              <b-form-group
                label="Longitud"
                label-for="longitudPrincipal"
              >
                <b-form-input
                  id="longitudPrincipal"
                  v-model="dataRegister.longitudPrincipal"
                  autofocus
                  trim
                  placeholder=""
                />
              </b-form-group>
            </b-col>
          </b-row>

          <h6
            class="text-primary"
          >
            <feather-icon icon="PhoneCallIcon" />
            <span class="align-middle ml-25">Datos de Contato</span>
          </h6>
          <hr style="border-top: 2px solid #7367f0;margin-bottom: 1rem !important;margin-top: 0 !important;">

          <b-row>
            <b-col
              md="6"
            >
              <b-form-group
                label="Email Principal"
                label-for="emailPrincipal"
              >
                <b-form-input
                  id="emailPrincipal"
                  v-model="dataRegister.emailPrincipal"
                  autofocus
                  trim
                  placeholder=""
                />
              </b-form-group>
            </b-col>
            <b-col
              md="6"
            >
              <b-form-group
                label="Celular Principal"
                label-for="celularPrincipal"
              >
                <b-form-input
                  id="celularPrincipal"
                  v-model="dataRegister.celularPrincipal"
                  autofocus
                  trim
                  placeholder=""
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              md="6"
            >
              <b-form-group
                label="Email Cilindro"
                label-for="emailCilindro"
              >
                <b-form-input
                  id="emailCilindro"
                  v-model="dataRegister.emailCilindro"
                  autofocus
                  trim
                  placeholder=""
                />
              </b-form-group>
            </b-col>
            <b-col
              md="6"
            >
              <b-form-group
                label="Celular Cilindro"
                label-for="celularCilindro"
              >
                <b-form-input
                  id="celularCilindro"
                  v-model="dataRegister.celularCilindro"
                  autofocus
                  trim
                  placeholder=""
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              md="6"
            >
              <b-form-group
                label="Email Granel"
                label-for="emailGranel"
              >
                <b-form-input
                  id="emailGranel"
                  v-model="dataRegister.emailGranel"
                  autofocus
                  trim
                  placeholder=""
                />
              </b-form-group>
            </b-col>
            <b-col
              md="6"
            >
              <b-form-group
                label="Celular Granel"
                label-for="celularGranel"
              >
                <b-form-input
                  id="celularGranel"
                  v-model="dataRegister.celularGranel"
                  autofocus
                  trim
                  placeholder=""
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              md="12"
            >
              <b-form-group
                label="Horario atención"
                label-for="horarioAtencionPrincipal"
              >
                <b-form-input
                  id="horarioAtencionPrincipal"
                  v-model="dataRegister.horarioAtencionPrincipal"
                  autofocus
                  trim
                  placeholder=""
                />
              </b-form-group>
            </b-col>
          </b-row>

          <h6
            class="text-primary"
          >
            <feather-icon icon="Share2Icon" />
            <span class="align-middle ml-25">Redes Sociales</span>
          </h6>
          <hr style="border-top: 2px solid #7367f0;margin-bottom: 1rem !important;margin-top: 0 !important;">

          <b-row>
            <b-col
              md="6"
            >
              <b-form-group
                label="Facebook"
                label-for="facebook"
              >
                <b-form-input
                  id="facebook"
                  v-model="dataRegister.facebook"
                  autofocus
                  trim
                  placeholder=""
                />
              </b-form-group>
            </b-col>
            <b-col
              md="6"
            >
              <b-form-group
                label="Instagram"
                label-for="instagram"
              >
                <b-form-input
                  id="instagram"
                  v-model="dataRegister.instagram"
                  autofocus
                  trim
                  placeholder=""
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              md="6"
            >
              <b-form-group
                label="Tiktok"
                label-for="tiktok"
              >
                <b-form-input
                  id="tiktok"
                  v-model="dataRegister.tiktok"
                  autofocus
                  trim
                  placeholder=""
                />
              </b-form-group>
            </b-col>
            <b-col
              md="6"
            >
              <b-form-group
                label="Youtube"
                label-for="youtube"
              >
                <b-form-input
                  id="youtube"
                  v-model="dataRegister.youtube"
                  autofocus
                  trim
                  placeholder=""
                />
              </b-form-group>
            </b-col>
          </b-row>

          <h6
            class="text-primary"
          >
            <feather-icon icon="ChevronsRightIcon" />
            <span class="align-middle ml-25">Otros</span>
          </h6>
          <hr style="border-top: 2px solid #7367f0;margin-bottom: 1rem !important;margin-top: 0 !important;">

          <b-row>
            <b-col
              md="4"
            >
              <b-form-group
                label="Id Video Youtube"
                label-for="idVideoHome"
              >
                <b-form-input
                  id="idVideoHome"
                  v-model="dataRegister.idVideoHome"
                  autofocus
                  trim
                  placeholder=""
                />
              </b-form-group>
            </b-col>
          </b-row>

          <div class="d-flex mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              type="button"
              @click="saveForm"
            >
              Actualizar
            </b-button>
          </div>
        </b-form>
      </div>
    </b-card>
  </div>
</template>
<script>
import { BCard, BRow, BCol, BForm, BFormGroup, BFormInput, BFormTextarea, BButton } from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import store from '@/store'
import { useNotify } from '@/helpers/toast'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BButton,
  },
  directives: {
    Ripple,
  },
  setup(props, context) {
    const { notify } = useNotify(context)
    const dataRegister = ref({})
    const isBusy = ref(true)

    const resetForm = () => {
      dataRegister.value = {}
    }

    const getData = async () => {
      isBusy.value = true
      store
        .dispatch('portal/DATO_GENERAL_FIND_ALL')
        .then(response => {
          dataRegister.value = response
        })
        .catch(() => {
          notify('Ha ocurrido un error', 'Intentelo en otro momento.', 'danger')
        })
        .finally(() => {
          isBusy.value = false
        })
    }

    const saveForm = async () => {
      const service = 'portal/DATO_GENERAL_UPDATE'
      await store.dispatch(service, dataRegister.value)
        .then(response => {
          console.log(response)
          notify('Operación exitosa', 'Ha actualizado la información correctamente', 'success')
          getData()
        })
        .catch(error => {
          console.log(error)
          notify('Ha ocurrido un error', 'Intentelo en otro momento.', 'danger')
        })
    }

    getData()
    return {
      dataRegister,
      resetForm,
      saveForm,
    }
  },
}
</script>
<style lang="scss">
</style>
